import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-32 px-6 bg-brand-black relative" data-id="element-9">
      <div className="max-w-4xl mx-auto text-center" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-11">
          <h2 className="font-serif text-4xl md:text-5xl text-brand-gold mb-8" data-id="element-12">
            A Premier Dining Destination
          </h2>

          <div className="w-12 h-px bg-brand-gold/50 mx-auto mb-10" data-id="element-13"></div>

          <p className="text-lg md:text-xl leading-relaxed text-brand-offwhite/80 mb-8" data-id="element-14">
            Located in the heart of downtown Paducah, Grill 211 offers an
            unparalleled culinary experience. We blend the timeless elegance of
            a classic steakhouse with the vibrant energy of a modern craft
            cocktail lounge.
          </p>

          <p className="text-base md:text-lg leading-relaxed text-brand-offwhite/60" data-id="element-15">
            Our culinary team meticulously sources the finest local ingredients
            and premium cuts, while our mixologists craft innovative libations
            that perfectly complement every dish. Whether you're joining us for
            an intimate dinner, a celebratory feast, or an evening of
            sophisticated spirits, Grill 211 promises an atmosphere of warm,
            inviting luxury.
          </p>
        </motion.div>
      </div>
    </section>;
}